import { del, get, post, put } from '../utility/http';
import { InspectionAnalisysHistoryJob,  
  InspectionAnalysisData, 
  InspectionAnalysisFlights  } 
  from '../model/inspectionAnalysisInterface';
import { getAssetsLayerDTOById } from './infrastructuresManagementApi';
import { AssetDTO } from '../model/infrastructureInterfaces';
import { fetchjobHistoryDetail } from './jobDetailAPI';

const colorArray = [
  '#00B3E6',
  '#FF6633',
  '#FFB399',
  '#FF33FF',
  '#FFFF99',
  '#E6B333',
  '#3366E6',
  '#999966',
  '#809980',
  '#E6FF80',
  '#1AFF33',
  '#999933',
  '#FF3380',
  '#CCCC00',
  '#66E64D',
  '#4D80CC',
  '#FF4D4D',
  '#99E6E6',
  '#6666FF'
];
  
export async function sendDataAssignToUser(defect: InspectionAnalysisData, 
  username: string, ctx: string) {
  try {
    const response: any = await put(
      `/defects/ctx/${ctx}/${username??''}${username?'/':''}${defect?.defectId}`,
      true,
      {},
      defect
    );
    return response;
 
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}



export async function sendDataUnassignToUser(defect: InspectionAnalysisData, 
  username: string, ctx: string) {
  try {
    const response: any = await del(
      `/defects/ctx/${ctx}/${username}/${defect?.defectId}`,
      true,
      {},
      defect
    );
    return response;
 
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchDataAssign(role: string, ctx: string) {
  try {
    const response: any = await get(
      `/federation/users/list?roles=${role}&groups=${ctx}`,
      true,
      {}
    );
    return response;

    //return (response as any).data;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchData(ctx: string) {

  try 
  {
    const response: any = await get(
      `/defects/ctx/${ctx}`,
      true,
      {}
    );
    const defects: InspectionAnalysisData[] = response.data; 

    const runsId : any[] = [];
    const layers : any[] = [];
    let indexColor = 0;

    for await (const defect of defects) {
      defect.flights = [];
      defect.assets = [];
      for (const runId of (defect.tracks ?? [])) {
        if (runsId.filter((it: any) => it.runId === runId).length == 0) {
         
          const temp = await getTypeFromrunId(runId, ctx);


          const tempJob: any = await fetchjobHistoryDetail(runId, temp?.length > 0 ?
            (temp[0].types.length > 0 ? temp[0].types[0] : '') : '');
          const jobHistory: InspectionAnalisysHistoryJob[] = tempJob?.data ?? [];
          const coords : number[][] = [];
        
          jobHistory.forEach((fh) => {
            coords.push( [fh.geom.coordinates[0],
              fh.geom.coordinates[1], fh.geom.coordinates[2]]); 
            
          });

          const flight: InspectionAnalysisFlights = {
            id: temp?.length > 0 ? temp[0].jobId : '',
            label: temp?.length > 0 ? temp[0].jobLabel : '',
            coords: coords, 
            color:  colorArray[indexColor++]
          }; 
          indexColor = indexColor>colorArray.length-1?0:indexColor;
          runsId.push({runId: runId, flight: flight});
          
        }
        defect.flights.push(runsId.filter((it: any) => it.runId === runId)[0].flight);
      }
      const layerId = defect.infrastructureId;
      if (layerId) {
        if (layers.filter((it: any) => it.layerId === layerId).length == 0) {
          const dataLayer: any = await getAssetsLayerDTOById({
            context: localStorage.getItem('context') ?? '',
            layerId: layerId
          });
          layers.push({ layerId: layerId, data: dataLayer?.data ?? [] });

        }
        defect.assets = layers.filter((it: any) => it.layerId === layerId)[0].data;
      }
       
       



    } 

    return defects;

    //return (response as any).data;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

 

export async function getTypeFromrunId(runId: string, ctx: string) 
{
  try 
  {
    const response = await get(
      `/tracks/summary-no-uavid?ctx=${ctx}&runId=${runId}`,
      true,
      {}
    );
    //console.log('response API getTypeFromrunId');
    //console.log(response);

    const data = (response as any).data;

    return data;
  }
  catch (e: any) 
  {
    return Promise.reject(e.response ? e.response : e);
  }
}



export const uploadInspection = async ({
  body,
  context
}: {
  body: any;
  context: string; 
}) => {
  try {
    const response = await post(
      `/defects/ctx/${context}/defect/upload`,
      true,
      {},
      body,
      false,
      true,
      'multipart/form-data',
      300000
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
};